"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HelpStack = exports.SectionsStack = exports.MissingWrap = void 0;
const app_1 = require("@obvio/app");
const ui_1 = require("@obvio/ui");
exports.MissingWrap = (0, app_1.styled)(app_1.Text) `
  font-weight: 700;
  font-size: 1.5rem;
  ${(theme) => theme.flexCenter}
`;
exports.SectionsStack = (0, app_1.styled)(ui_1.Stack) `
  border-top: 1px solid ${(theme) => theme.colors.gray.light};
`;
exports.HelpStack = (0, app_1.styled)(ui_1.Stack) `
  margin-top: 4rem !important;
  > div {
    align-items: center;
  }

  span,
  a,
  svg {
    font-size: 0.875rem;
    letter-spacing: 0.25px;
    color: ${(theme) => theme.colors.gray};
  }
`;
